import { Timer } from './timer';
/**
 * ## cortex:std:retry
 * Module for retrying a given function either x amount of times
 * or every x seconds
 */
export var Retry;
(function (Retry) {
    /** Retry a function every x amount of seconds, regardless of success or failure */
    Retry.byBruteForce = (fn, options) => {
        const defaultOption = {
            every: 1000,
            for: 1,
            hooks: [],
            ...(options ? options : {}),
        };
        return new Promise((resolve, reject) => {
            let attempts = 0;
            let finishedRequest = false;
            const disposer = Timer.repeat(() => {
                proxy(attempts++);
            }, defaultOption.every, true);
            async function proxy(attempt) {
                var _a;
                if (attempt > defaultOption.for && !finishedRequest) {
                    disposer();
                    reject(`request did not finish in ${defaultOption.for} attempts`);
                }
                try {
                    const resolvedIntoThis = await fn();
                    if (!finishedRequest) {
                        disposer();
                        finishedRequest = true;
                        resolve(resolvedIntoThis);
                    }
                }
                catch (error) {
                    (_a = defaultOption.hooks) === null || _a === void 0 ? void 0 : _a.forEach((hook) => hook());
                }
            }
        });
    };
    /** Retry a function for a given amount of times in case if fails */
    Retry.the = (fn, options) => {
        const defaultOption = {
            againAfter: 1000,
            for: 1,
            hooks: [],
            ...(options ? options : {}),
        };
        return new Promise((resolve, reject) => {
            let attempts = 0;
            async function proxy(attempt) {
                var _a;
                try {
                    const resolvedIntoThis = await fn();
                    resolve(resolvedIntoThis);
                }
                catch (error) {
                    (_a = defaultOption.hooks) === null || _a === void 0 ? void 0 : _a.forEach((hook) => hook());
                    if (attempt <= defaultOption.for) {
                        retry();
                    }
                    else {
                        reject(error);
                    }
                }
            }
            function retry() {
                setTimeout(() => {
                    proxy(attempts++);
                }, defaultOption.againAfter);
            }
            proxy(attempts++);
        });
    };
})(Retry || (Retry = {}));
